import { motion } from "framer-motion";

/**
 * Smooth premium grid lines — SVG-based for crisp rendering on all DPR.
 * Sits in the hero background with a soft radial mask so lines fade to edges.
 */
export default function HeroGridLines() {
  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{
        WebkitMaskImage:
          "radial-gradient(ellipse 70% 60% at 50% 45%, hsl(0 0% 0% / 0.9), transparent 75%)",
        maskImage:
          "radial-gradient(ellipse 70% 60% at 50% 45%, hsl(0 0% 0% / 0.9), transparent 75%)",
      }}
    >
      <svg
        className="absolute inset-0 h-full w-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="hero-grid"
            width="64"
            height="64"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 64 0 L 0 0 0 64"
              fill="none"
              stroke="hsl(var(--primary) / 0.10)"
              strokeWidth="0.6"
            />
          </pattern>
          <pattern
            id="hero-grid-major"
            width="320"
            height="320"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 320 0 L 0 0 0 320"
              fill="none"
              stroke="hsl(var(--primary) / 0.18)"
              strokeWidth="0.8"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#hero-grid)" />
        <rect width="100%" height="100%" fill="url(#hero-grid-major)" />
      </svg>

      {/* Animated horizon sweep across grid */}
      <motion.div
        initial={{ x: "-30%" }}
        animate={{ x: "130%" }}
        transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        className="absolute inset-y-0 w-1/3"
        style={{
          background:
            "linear-gradient(90deg, transparent, hsl(var(--primary) / 0.06) 50%, transparent)",
        }}
      />
    </div>
  );
}
